import { useState } from 'react';

function JavaScriptModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to JavaScript",
      content: [
        "What is JavaScript?",
        "History of JavaScript",
        "Setting up the development environment",
        "JavaScript syntax and comments",
        "Using console for debugging",
        "Variables and data types",
        "Basic operators and expressions",
      ]
    },
    {
      title: "Module 2: Control Structures",
      content: [
        "If-else statements",
        "Switch statements",
        "For loop, while loop, and do-while loop",
        "Break and continue statements",
        "Logical and comparison operators",
      ]
    },
    {
      title: "Module 3: Functions and Scope",
      content: [
        "Defining and invoking functions",
        "Function parameters and return values",
        "Arrow functions and anonymous functions",
        "Scope and closures in JavaScript",
        "Higher-order functions",
      ]
    },
    {
      title: "Module 4: Working with Arrays and Objects",
      content: [
        "Creating and manipulating arrays",
        "Array methods (map, filter, reduce)",
        "Introduction to objects",
        "Object properties and methods",
        "Looping through objects and arrays",
      ]
    },
    {
      title: "Module 5: DOM Manipulation",
      content: [
        "Understanding the Document Object Model (DOM)",
        "Selecting and modifying DOM elements",
        "Event handling (click, hover, keypress, etc.)",
        "Adding and removing elements",
        "Creating dynamic content with JavaScript",
      ]
    },
    {
      title: "Module 6: Asynchronous JavaScript",
      content: [
        "Callbacks and asynchronous programming",
        "Promises in JavaScript",
        "Using async/await for asynchronous code",
        "Handling errors in asynchronous code",
        "Making API requests with fetch",
      ]
    },
    {
      title: "Module 7: Working with APIs",
      content: [
        "Introduction to REST APIs",
        "Fetching data from APIs",
        "Parsing and displaying JSON data",
        "Error handling in API requests",
        "Creating a simple project with API data",
      ]
    },
    {
      title: "Module 8: ES6+ Features",
      content: [
        "Let and const keywords",
        "Template literals",
        "Destructuring arrays and objects",
        "Spread and rest operators",
        "Classes and modules",
      ]
    },
    {
      title: "Module 9: JavaScript in the Browser",
      content: [
        "Understanding localStorage and sessionStorage",
        "Browser events and event listeners",
        "Form validation with JavaScript",
        "Cookies and session management",
        "Basic security considerations",
      ]
    },
    {
      title: "Module 10: Advanced Topics and Best Practices",
      content: [
        "Error handling and debugging",
        "JavaScript performance optimization",
        "Modular JavaScript (import/export)",
        "Functional programming concepts",
        "Overview of popular JavaScript frameworks",
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">JavaScript Full Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default JavaScriptModule;
